import React, { useEffect, useState } from 'react'
import { VariableUser } from './VariableUser'
import AddUser from './AddUser'
import EditUser from './EditUser'
import FilterUser from './FilterUser'
import { AbstructVar } from '../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../components/general/general-component/abstruct-component/AbstructLang'
import { useSelectorCustom } from '../../components/general/general-component/abstruct-component/useSelectorCustom'
import { DeleteComponent } from '../../components/general/general-component/abstruct-component/DeleteComponent'
import { blockUser, deleteUser, loadUsers } from '../../store/Actions/ActionUser'
import SectionTopOfTable from '../../components/general/general-component/section-top-of-table/SectionTopOfTable'
import Warning from '../../components/general/general-component/warning-delete/Warning'
import { ColumnUser } from '../../components/general/general-component/columns-component/ColumnUser'
import Table2 from '../../components/table/Table2'
import InnerLoader from '../../components/general/inner-loader/InnerLoader'
import { UsePermissions, hasPermissions } from '../../components/general/general-component/abstruct-component/UsePermissions'
import CheckPermissions from '../../components/general/general-component/check-permissions'
import CheckLazyLoader from '../../components/general/general-component/check-lazy-loader'

const Users = () => {
    const { permissionss, loadingMainPermission } = UsePermissions();
    const userss = hasPermissions([{ name: "users" }], permissionss);
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { users, loadingUsers } = useSelectorCustom()
    const { state, setOpen, handleEdit, setopenEdit } = VariableUser()
    const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
    const [usersArr, setUsersArr] = useState([])
    const [isDeleted, setIsDeleted] = useState('')
    const [idDeleted, setIdDeleted] = useState(null)
    
    useEffect(() => {
        if (isDeleted && idDeleted) {
            const updatedArr = [...usersArr];
            const indexToDelete = updatedArr.findIndex(item => item.id === idDeleted);
            if (indexToDelete !== -1) {
                updatedArr.splice(indexToDelete, 1);
                setUsersArr(updatedArr);
            }
        }
    }, [isDeleted, idDeleted, usersArr]);
    useEffect(() => {
        if (users?.length >= 0) {
            setUsersArr(users)
        }
    }, [users]);
    useEffect(() => {
        dispatch(loadUsers())
    }, []);
    const handleDelete = (id) => {
        dispatch(deleteUser(id, setloadDel, setIsDeleted, setIdDeleted));
    }
    const openAddUser = e => {
        e.preventDefault()
        setOpen(true)
    }
    const editStatus = (id, status) => {
        let newStatus;
        if (status === 1) {
            newStatus = 0
        } else {
            newStatus = 1
        }
        dispatch(blockUser(id, newStatus, setloadDel));
    }
    const { columns } = ColumnUser(translate, warning, handleEdit, editStatus, langLocal)
    return (
        <CheckLazyLoader route='/dashboard/users' >
            <CheckPermissions array={userss} loadingMainPermission={loadingMainPermission} >
                <main>
                    <FilterUser translate={translate} />
                    <div className="div_table margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                        <SectionTopOfTable langLocal={langLocal} title={translate('users')} titleBtn={translate('adduser')} FunctionBtn={openAddUser} />
                        {
                            loadingUsers == false ? (
                                <Table2 col={columns} roo={usersArr} />
                            ) : <InnerLoader />
                        }
                    </div>
                </main>
            </CheckPermissions>
            {
                state.open && (
                    <AddUser open={state.open} setOpen={setOpen} />
                )
            }
            {
                stateD.deletee == true ? (
                    <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                ) : <></>
            }
            {
                state.openEdit && (
                    <EditUser arr={state.arr1} open={state.openEdit} setOpen={setopenEdit} />
                )
            }
        </CheckLazyLoader>
    )
}

export default Users
